/**
 * Redux store partition definition.
 */
export default {
    /**
     * Store partition key.
     */
    Key: 'USER',

    /**
     * Action types
     */
    Type: {
        EXEC: 'EXEC',
        COMMIT: 'COMMIT',
        ROLLBACK: 'ROLLBACK'
    },

    /**
     * Partition states.
     */
    State: {
        PREPARING: 'PREPARING',
        EXECUTING: 'EXECUTING',
        READY: 'READY',
        FAILED: 'FAILED'
    }
};
